import OrderListPage from './order-list';

export default OrderListPage;